import Slider, { SliderThumb } from "@mui/material/Slider";
import chroma from "chroma-js";
import React from "react";
import Grid from "@mui/material/Grid2";
import { Typography } from "@mui/material";
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import AcUnitIcon from '@mui/icons-material/AcUnit';

export default function PlayerPage({
  stat,
  value,
  percentile,
  percentile_raw,
  isDesktop
}: {
  stat: string;
  value: string;
  percentile: number;
  percentile_raw: number;
  isDesktop: boolean;
}) {
  const thumbscale = chroma.scale(["#3661AD", "#C2C2C2", "#D82129"]);
  const trackscale = chroma.scale(["#3661AD", "#C2C2C2", "#D82129"]);
  const activescale = chroma.scale(["#3661AD", "#C2C2C2", "#D82129"]);
  //console.log(value, percentile, percentile_raw)
  function ThumbComponent(props: ThumbComponentProps) {
    const { children, ...other } = props;
    
    return (
      <div>
        <SliderThumb {...other}>
          {children}
          <div style={{ position: 'relative', display: 'inline-block' }}>
          {percentile_raw === 1 && (
            <LocalFireDepartmentIcon style={{
              position: 'absolute',
              fontSize: '2.2em',
              color: 'orange',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 1,
            }} />
          )}
          {percentile_raw < .015 && (
            <AcUnitIcon style={{
              position: 'absolute',
              fontSize: '1.9em',
              color: 'blue',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 1,
            }} />
          )}
          <p style={{
            color: "white",
            fontWeight: "bold",
            fontSize: "0.8em",
            position: 'relative',
            zIndex: 2,
            margin: 0,
          }}>
            {Number.isNaN(percentile) ? "NQ":(percentile_raw > .99 && percentile_raw < 1 ? 99 : Math.round(props.value))}
          </p>
          </div>
        </SliderThumb>
      </div>
    );
  }

  interface ThumbComponentProps extends React.HTMLAttributes<unknown> {
    value: number;
  }
  return (
    <div>
      <Grid
        container
        spacing={1}
        columns={16}
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        sx={isDesktop ? { marginTop: "-1px", marginBottom: "-1px" } : { marginTop: "-7px", marginBottom: "-7px" }}
      >
        <Grid size={isDesktop ? 3 : 4}>
          <Typography variant="body2" textAlign="right">
            {stat}
          </Typography>
        </Grid>
        <Grid size={isDesktop ? 9 : 8}>
          <Slider
            slotProps={{
              thumb: {
                value: percentile,
              } as ThumbComponentProps,
            }}
            slots={{
              thumb: ThumbComponent,
            }}
            value={percentile}
            step={10}
            marks
            min={0}
            max={100}
            disabled
            sx={{
              "& .MuiSlider-thumb": {
                backgroundColor: "var(--thumb)",
                outline: "2px solid white",
              },
              "& .MuiSlider-track": {
                backgroundColor: "var(--track)",
                height: 18,
                borderRadius: 0,
              },
              "& .MuiSlider-rail": {
                backgroundColor: "var(--rail)",
                height: 6,
                borderRadius: 0,
              },
              "& .MuiSlider-active": {
                backgroundColor: "var(--active)",
                borderRadius: 0,
              },
            }}
            style={
              {
                "--thumb": thumbscale(percentile_raw).toString(),
                "--track": trackscale(percentile_raw).toString(),
                "--rail": "#C7DCDC",
                "--active": activescale(percentile_raw).toString(),
              } as React.CSSProperties
            }
          />
        </Grid>
        <Grid size={4}>
          <Typography variant="body2" textAlign="right" marginRight="20px">
            {value.toString()[0] === '0' && value.toString() !== '0%' ? value.toString().substring(1) : value}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}
